<script setup>
import { HrSwitch } from '../primitives';

/**
 * On/Off switch — a binary toggle with check/close icons reinforcing the on/off state.
 *
 * @status recommended
 * @group forms-input
 * @useWhen A binary toggle is needed with clear on/off icon affordance
 * @related HrVisibilitySwitch
 * @related HrSettingSwitch
 * @a11y Native switch role; activates with Space. Icons reinforce on/off state beyond color alone.
 * @event update:modelValue Forwarded from HrSwitch; new boolean value.
 */
defineOptions({ name: 'HrOnOffSwitch' });

defineProps({
  /** Current on/off state. */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** Optional text label displayed alongside the switch. */
  label: {
    type: String,
    default: null,
  },
  /** Prevents interaction and dims the switch. */
  disable: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <hr-switch
    icon-on="check"
    icon-off="close"
    v-bind="{ ...$props, ...$attrs }"
  />
</template>
